<script>
import SnackbarContainer from './components/SnackBar/Container.vue';
import { setColorTheme } from 'dashboard/helper/themeHelper';
// FORK_PATCH: brand-theme — default green on unauthenticated auth pages (login/signup/reset)
import {
  applyBrandTheme,
  BRAND_THEME_DEFAULT_ACTIVE,
} from 'custom/dashboard/helper/brandThemeHelper';

export default {
  components: { SnackbarContainer },
  data() {
    return { theme: 'light' };
  },
  mounted() {
    applyBrandTheme(BRAND_THEME_DEFAULT_ACTIVE);
    this.initializeColorTheme();
    this.listenToThemeChanges();
    this.setLocale(window.chatwootConfig.selectedLocale);
  },
  methods: {
    initializeColorTheme() {
      const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      setColorTheme(isDark);
      this.theme = isDark ? 'dark' : 'light';
    },
    listenToThemeChanges() {
      const mql = window.matchMedia('(prefers-color-scheme: dark)');

      mql.onchange = e => {
        setColorTheme(e.matches);
        this.theme = e.matches ? 'dark' : 'light';
      };
    },
    setLocale(locale) {
      if (locale) {
        this.$root.$i18n.locale = locale;
      }
    },
  },
};
</script>

<template>
  <div class="h-full min-h-screen w-full antialiased" :class="theme">
    <router-view />
    <SnackbarContainer />
  </div>
</template>

<style lang="scss">
@tailwind base;
@tailwind components;
@tailwind utilities;

@import '../dashboard/assets/scss/next-colors';

html,
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  @apply h-full w-full;

  input,
  select {
    outline: none;
  }
}

.text-link {
  @apply text-n-brand font-medium hover:opacity-80;
}

.v-popper--theme-tooltip .v-popper__inner {
  background: black !important;
  font-size: 0.75rem;
  padding: 4px 8px !important;
  border-radius: 6px;
  font-weight: 400;
}

.v-popper--theme-tooltip .v-popper__arrow-container {
  display: none;
}
</style>
